export default [
  {
    "to": { "name": "about-us" },
    "text": "О компании",
    "page_presence_setting_name": "about_us",
    "page_title_setting_name": "about_us"
  },
  {
    "to": { "name": "delivery-and-payment" },
    "text": "Доставка и оплата",
    "page_presence_setting_name": "delivery_and_payment",
    "page_title_setting_name": "delivery_and_payment"
  },
  {
    "to": { "name": "blog-list" },
    "text": "Блог",
    "page_presence_setting_name": "blog",
    "page_title_setting_name": "blog"
  },
  {
    "to": { "name": "offers-list" },
    "text": "Акции",
    "page_presence_setting_name": "offers",
    "page_title_setting_name": "offers"
  }
]
